var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{attrs:{"name":"header"}}),_vm._v(" "),_c('main',[_c('transition',{attrs:{"enterActiveClass":"animated fadeIn","leaveActiveClass":"animated fadeOut","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('router-view',{attrs:{"name":"footer"}}),_vm._v(" "),_c('gh-back-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }